import { createReducer } from '@src/redux/helpers/createReducer';
import {
  CLEAR_REGISTRATION_DATA,
  SEARCH_REGISTRATION_STATUS,
} from './constants';

const initialState = {
  tinRegistrationStatus: {},
  multitinRegistration: [],
  searchRegistrationStatusSaga: {
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const tinRegistarationStatusReducer = createReducer(initialState, {
  [`${SEARCH_REGISTRATION_STATUS}_SUCCESS`]: (state, action) => {
    const a = {
      ...state,
      tinRegistrationStatus: action.payload[0],
      multitinRegistration: action.payload,
      searchRegistrationStatusSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
    return a;
  },
  [`${SEARCH_REGISTRATION_STATUS}_STARTED`]: (state, action) => {
    return {
      ...state,
      searchRegistrationStatusSaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
  [`${SEARCH_REGISTRATION_STATUS}_ERROR`]: (state, action) => {
    return {
      ...state,
      searchRegistrationStatusSaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },

  [CLEAR_REGISTRATION_DATA]: () => {
    return {
      tinRegistrationStatus: initialState.tinRegistrationStatus,
      multitinRegistration: initialState.multitinRegistration,
    };
  },
});
